module.exports = __webpack_public_path__ + "media/application/images/demo/content_4-abfe7413fb47c8bec26d9c1a06386969.jpg";